export default {"src":"/_next/static/media/app-download-hero.2f1e9201.svg","height":571,"width":428,"blurWidth":0,"blurHeight":0};